import * as angular from 'angular';

import { ComponentDefinition, VariableTableViewModel } from '../../../../models';

class FlatTableController implements angular.IComponentController {
    loadingMessage: string;
    readonly isLoading: boolean;
    readonly viewModels: VariableTableViewModel[];

    static $inject = [];
}

export const wtFlatTable: ComponentDefinition = {
    componentId: 'wtFlatTable',
    controller: FlatTableController,
    template: require('./flatTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLoading: '<',
        viewModels: '<'
    }
};
